export const TERMS = {
    title: 'TERMS & CONDITIONS',
    content: `
     <div class="container">

        <h2>1. Company Information</h2>
        <p>MedicAI<br>Email: <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a></p>

        <h2>2. Service Description</h2>
        <p>MedicAI is a patient management platform that streamlines administrative tasks, dramatically freeing up physicians' time. By automating note-taking and other burdensome duties, MedicAI empowers clinicians to focus their energy on providing exceptional patient care.</p>

        <h2>3. User Responsibilities</h2>
        <p>Users of MedicAI are expected to:</p>
        <ul>
            <li>Ensure the accuracy and completeness of the data entered into the MedicAI system.</li>
            <li>Use the software in compliance with all applicable laws and regulations.</li>
            <li>Maintain the confidentiality of their account information and immediately notify MedicAI of any unauthorized use.</li>
            <li>Not misuse the software, including attempting to access unauthorized features or data.</li>
        </ul>

        <h2>4. Privacy and Data Protection</h2>
        <p>MedicAI is committed to protecting user data in accordance with applicable laws. All data is encrypted and will not be shared with third parties without explicit consent from the user. MedicAI complies with the Protection of Personal Information Act (POPIA) in South Africa.</p>

        <h2>5. Payment and Subscription</h2>
        <p>Doctors who wish to maintain their own patient lists are required to subscribe to MedicAI. The subscription fee is ZAR2000 per month, which includes ZAR200 worth of AI tokens each month. AI tokens carry over each month and never expire. Subscriptions are billed monthly and can be canceled at any time through the MedicAI platform or via written request to <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>.</p>

        <h2>6. Intellectual Property</h2>
        <p>MedicAI retains all rights to the software and the underlying ideas. Users are granted a non-exclusive, non-transferable license to use the software according to these terms and conditions.</p>

        <h2>7. Limitation of Liability</h2>
        <p>MedicAI does not accept liability for any content produced by AI. MedicAI is not liable for any indirect, incidental, or consequential damages arising from the use of the platform. Users acknowledge that the use of the software is at their own risk.</p>

        <h2>8. Termination</h2>
        <p>MedicAI reserves the right to terminate a user's subscription for violation of these terms, non-payment, or misuse of the platform. Users may terminate their subscription at any time through the MedicAI platform or via written request to <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>.</p>

        <h2>9. Governing Law</h2>
        <p>These terms and conditions are governed by the laws of South Africa.</p>

        <h2>10. Changes to Terms</h2>
        <p>MedicAI reserves the right to modify these terms and conditions at any time. Any changes will be communicated to users via email. Continued use of the service after changes have been made constitutes acceptance of the updated terms.</p>

        <h2>11. Miscellaneous</h2>
        <p>MedicAI does not use tracking technologies for targeted advertising. Users should be aware that third-party services integrated with MedicAI may have their own terms and conditions, which users are responsible for reviewing and complying with.</p>
     </div>
    `
};

export const PRIVACY = {
    title: 'PRIVACY POLICY',
    content: `
    <div class="container">

        <p>This Privacy Policy explains how MedicAI ("we", "us", "our") collects, uses, and protects your information when you use our services. By using MedicAI, you agree to the terms of this Privacy Policy.</p>

        <h2>1. Company Information</h2>
        <p>MedicAI<br>Email: <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a></p>

        <h2>2. Types of Data Collected</h2>
        <p>We collect the following types of information:</p>
        <ul>
            <li><strong>Personal Information:</strong> This includes name, email address, and medical information.</li>
            <li><strong>Non-Personal Information:</strong> This includes browser type, operating system, and other technical information.</li>
        </ul>

        <h2>3. How Data is Collected</h2>
        <p>We collect data through forms that you fill out when using our services.</p>

        <h2>4. Use of Data</h2>
        <p>We use the collected data to:</p>
        <ul>
            <li>Provide our services.</li>
            <li>Improve user experience.</li>
        </ul>
        <p>We do not use your data for marketing purposes.</p>

        <h2>5. Data Sharing</h2>
        <p>We do not share your data with third parties without your prior consent. If you provide consent, information may be shared with authorized physicians to ensure comprehensive patient care.</p>

        <h2>6. Data Security</h2>
        <p>We implement various security measures, including encryption, access controls, and auditing, to protect your data.</p>

        <h2>7. User Rights</h2>
        <p>As per the Protection of Personal Information Act (POPIA) in South Africa, you have the right to:</p>
        <ul>
            <li>Access your personal data.</li>
            <li>Request correction of inaccurate data.</li>
            <li>Request deletion of your data.</li>
        </ul>
        <p>To exercise these rights, please contact us at <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>.</p>

        <h2>8. Data Retention</h2>
        <p>We retain your data for as long as necessary to provide our services. You can request the deletion of your data at any time by contacting us.</p>

        <h2>9. Cookies and Tracking Technologies</h2>
        <p>We do not use cookies or other tracking technologies for targeted advertising.</p>

        <h2>10. Changes to the Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of any changes via email. Continued use of our services after changes have been made constitutes acceptance of the updated policy.</p>

        <h2>11. International Data Transfers</h2>
        <p>We do not transfer your data internationally.</p>
    </div>
    `
};

export const POPIA_PAIA = {
    title: 'POPIA & PAIA MANUAL',
    content: `
    <div class="container">

        <h2>1. Introduction</h2>
        <p>MedicAI is an AI-powered electronic medical record (EMR) system that streamlines administrative processes for medical practices in South Africa. This manual outlines our compliance with the Protection of Personal Information Act (POPIA) and the Promotion of Access to Information Act (PAIA).</p>

        <h2>2. Company Information</h2>
        <p>MedicAI<br>Email: <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a></p>

        <h2>3. Designated Information Officer</h2>
        <p>Name: [Designated Information Officer's Name]<br>Email: <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a></p>

        <h2>4. Description of Records</h2>
        <p>MedicAI holds the following categories of records:</p>
        <ul>
            <li>Personal Information: Name, email address, medical information.</li>
            <li>Non-Personal Information: Browser type, operating system, and other technical data.</li>
        </ul>

        <h2>5. Purpose of Processing</h2>
        <p>MedicAI processes personal information to:</p>
        <ul>
            <li>Provide and improve our services.</li>
            <li>Ensure accurate and efficient medical record-keeping.</li>
            <li>Comply with legal and regulatory requirements.</li>
        </ul>
        <p>We do not process personal information for marketing purposes without consent.</p>

        <h2>6. Data Subject Rights</h2>
        <p>Under POPIA, data subjects have the right to:</p>
        <ul>
            <li>Access their personal information.</li>
            <li>Request correction of inaccurate data.</li>
            <li>Request deletion of their personal data.</li>
        </ul>
        <p>To exercise these rights, please contact us at <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>.</p>

        <h2>7. Information Security</h2>
        <p>MedicAI implements the following security measures to protect personal information:</p>
        <ul>
            <li>Encryption of data at rest and in transit.</li>
            <li>Access controls to limit data access to authorized personnel.</li>
            <li>Regular auditing of data security practices.</li>
        </ul>

        <h2>8. Access to Information</h2>
        <p>Under PAIA, individuals have the right to request access to records held by MedicAI. Requests for access can be made by contacting our Information Officer at <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>. A fee may be charged for processing access requests.</p>

        <h2>9. Third-Party Disclosures</h2>
        <p>MedicAI does not disclose personal information to third parties without prior consent. If consent is provided, information may be shared with authorized physicians to ensure comprehensive patient care.</p>

        <h2>10. Data Breach Management</h2>
        <p>In the event of a data breach, MedicAI will:</p>
        <ul>
            <li>Take immediate steps to contain the breach.</li>
            <li>Notify affected individuals and the relevant authorities as required by law.</li>
            <li>Conduct a thorough investigation to determine the cause and impact of the breach.</li>
        </ul>

        <h2>11. Amendments to the Manual</h2>
        <p>MedicAI reserves the right to amend this manual as necessary. Any updates will be communicated to users via email. Continued use of our services after changes have been made constitutes acceptance of the updated manual.</p>

        <h2>12. Contact Information</h2>
        <p>For any questions or concerns regarding this manual, please contact our Information Officer at <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a>.</p>
    </div>
    `
};